import React from "react";

export const validItineraryForm = ( formData, renderErrors ) => {
	
	let errors = [];

	if( !(formData.pax > 2) ){
		errors.push({key: "pax", msg: "Please make sure you enter a valid group size"});
	}

	if( formData.date.length < 5 ){
		errors.push({key: "date", msg: "Please make sure you enter a weekend date"});
	}

	if( formData.activities.length > 0 ){
		let invalidEvent = formData.activities.find( event => event.pax < 1 );
		if(invalidEvent){
			errors.push({key: "activities", msg: `Please make sure you select a valid group size for ${invalidEvent.name}`});
		}
	} else {
		if( !formData.superPackage ) {
			errors.push({key: "activities", msg: "You need to select at least one activity for your weekend"});
		}
	}

	if( !renderErrors ) {
		return errors.length == 0 ? true : false;
	} else {
		return errors;
	}
}

export const validSubmissionForm = ( formdata ) => {

}